import React from 'react';

interface DetailIconProps extends React.SVGProps<SVGSVGElement> {
	width?: number;
	height?: number;
	fill?: string;
}

export function DetailIcon({
	width = 24,
	height = 24,
	fill = 'currentColor',
	...props
}: Readonly<DetailIconProps>): JSX.Element {
	return (
		<svg
			{...props}
			fill="none"
			width={width}
			height={height}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g transform="translate(3 3)">
				<path
					d="M6.554 0C8.29816 6.87888e-06 9.96041 0.683071 11.1868 1.91211C13.4457 4.20173 13.6976 7.77598 11.8977 10.3291C11.8128 10.4495 11.7232 10.5679 11.6292 10.6836C11.6004 10.719 11.571 10.7541 11.5413 10.7891L11.9231 11.1719C11.9367 11.1637 11.9504 11.1552 11.9642 11.1475C12.0914 11.0762 12.2297 11.0223 12.3733 10.9854C12.5277 10.9457 12.689 10.9258 12.8499 10.9258C13.3675 10.9259 13.858 11.1441 14.2122 11.499L17.428 14.668C18.1908 15.4328 18.1911 16.6621 17.428 17.4268C17.0737 17.809 16.5828 18 16.0647 18C15.5471 18 15.0567 17.7816 14.7024 17.4268L11.4866 14.2031C10.9809 13.7183 10.8124 13.0023 10.9808 12.3564C11.0176 12.2153 11.0709 12.0776 11.1399 11.9463C11.1464 11.934 11.1527 11.9214 11.1595 11.9092L10.7776 11.5264C10.7372 11.5612 10.6968 11.5961 10.6556 11.6299C10.5473 11.7186 10.4358 11.8028 10.3226 11.8838C9.22962 12.6648 7.913 13.083 6.554 13.083C4.81021 13.083 3.14759 12.4008 1.92119 11.1719C-0.640439 8.63154 -0.640352 4.47971 1.92119 1.91211C3.17473 0.683062 4.81015 0 6.554 0ZM6.52666 1.86426C5.33967 1.86431 4.14475 2.33086 3.22685 3.22559C1.4052 5.05538 1.40655 8.03412 3.23076 9.8623C4.14689 10.7804 5.33949 11.247 6.52666 11.2471C7.71401 11.2471 8.90694 10.7798 9.82353 9.86133L9.82646 9.8584C11.6742 8.02971 11.6742 5.08064 9.82646 3.25195L9.82353 3.24902C8.90694 2.33057 7.71401 1.86426 6.52666 1.86426ZM6.5999 3.59961C7.01395 3.59963 7.34967 3.9356 7.3499 4.34961V5.84961H8.8499C9.26395 5.84963 9.59967 6.1856 9.5999 6.59961C9.5999 7.01381 9.2641 7.34959 8.8499 7.34961H7.3499V8.84961C7.3499 9.26381 7.0141 9.59959 6.5999 9.59961C6.18568 9.59961 5.8499 9.26382 5.8499 8.84961V7.34961H4.3499C3.93568 7.34961 3.5999 7.01382 3.5999 6.59961C3.60013 6.18559 3.93583 5.84961 4.3499 5.84961H5.8499V4.34961C5.85013 3.93559 6.18583 3.59961 6.5999 3.59961Z"
					fill={fill}
				/>
			</g>
		</svg>
	);
}
